import * as core from '../../../../../../../core'

import { query } from './requirement-details.query'

export const RESOURCE = {
  payload: {
    alias: 'requirement.details',
    description: 'Details view for a single requirement',
    name: 'Requirement Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
